 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/text/Cover'
 import TEXTBCC from '@/components/text/BCC'
 import TEXTTITLEPAGE from '@/components/text/titlepage'
 import TEXTCONTENTS from '@/components/text/Contents'
 import TEXTCHAPTER_ONE from '@/components/text/Chapter_One'
 import TEXTCHAPTER_TWO from '@/components/text/Chapter_Two'
 import TEXTCHAPTER_THREE from '@/components/text/Chapter_Three'
 import TEXTCHAPTER_FOUR from '@/components/text/Chapter_Four'
 import TEXTCHAPTER_FIVE from '@/components/text/Chapter_Five'
 import TEXTCHAPTER_SIX from '@/components/text/Chapter_Six'
 import TEXTEXCERPT from '@/components/text/Excerpt'
 import TEXTEXCERPT1 from '@/components/text/Excerpt1'
 import TEXTCOPYRIGHT from '@/components/text/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/Contents",
 			"name" : "text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/text/Chapter_One",
 			"name" : "text/Chapter_One",
 			"component" : TEXTCHAPTER_ONE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js